import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueGtag from "vue-gtag";

import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";

import * as Sentry from "@sentry/vue";

import './index.css'

import Store from './store';
import './registerServiceWorker'

// Determine the correct domain based on environment
const oauthDomain = process.env.VUE_APP_ENVIRONMENT === 'prod' 
  ? 'login.presentplanner.co' 
  : 'login.dev.presentplanner.co';

const amplifyConfig = {
  ...awsExports,
  oauth: {
    ...awsExports.oauth,
    domain: oauthDomain,
    scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: process.env.VUE_APP_ENVIRONMENT === 'prod' 
      ? 'https://presentplanner.co/' 
      : 'https://dev.presentplanner.co/',
    redirectSignOut: process.env.VUE_APP_ENVIRONMENT === 'prod' 
      ? 'https://presentplanner.co/' 
      : 'https://dev.presentplanner.co/',
    responseType: 'code'
  },
  aws_cognito_social_providers: ['Google']
};

Amplify.configure(amplifyConfig);

const app = createApp(App)

// VUE_APP_SENTRY_DSN must be set in CI/CD build environment variables
// VUE_APP_ENVIRONMENT should be 'prod' for production builds
Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: ["dev.presentplanner.co", "presentplanner.co", /^\//],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.VUE_APP_ENVIRONMENT || 'dev',
  });

app.use(router).use(Store).use(VueGtag, {config: { id: "AW-11227042698/BR0yCJG0ubwYEIqnvOkp" }}).mount("#app");
